import { useTranslation } from "react-i18next";
import BkCalendar from "./bkCalendar";
import Button from "components/button/default";
import BookInfCard from "./bkInfCard";
import { useBookInfContext } from "components/context/bookInfContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  alertControl,
  emailRegex,
  getDurationDate,
  phoneRegex,
  successControl,
} from "util/commAction";
import { useMutation } from "@tanstack/react-query";
import { resvRmApi } from "components/api/book";
import { logChkApi } from "components/api/user";
import DefaultModal from "components/modal/default";
import ModalPayInnner from "./pay";
import "./bookInf.scss";

export default function BookInf() {
  const { t } = useTranslation();
  const { pathname, state } = useLocation();
  // const lodInf = localStorage.getItem('lodInf') ?

  const bookInfRef = useRef<HTMLDivElement>(null);
  const resvInfRef = useRef<any>(null);
  const rmResvNoRef = useRef(null);
  const navigate = useNavigate();
  const { setIsSearch, bkStep, bookInf, onBookInf, onBkStep, userInf, terms } =
    useBookInfContext();

  useEffect(() => {
    if (!bookInf?.dates) {
      alertControl({
        isOpen: true,
        inner: "날짜를 선택하여 주세요.",
        click: () => {
          // navigate('/'+ )
        },
      });
    }
  }, []);

  const [isOpen, setIsOpen] = useState(false); //결제 결제 취소 모달창

  //객실 예약
  const bookMutation = useMutation({
    mutationFn: resvRmApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          const rmResvNo = data.rmResvNo;
          rmResvNoRef.current = rmResvNo;
          onBookInf({
            rmResvNo,
          });

          // 객실 결제 진행
          const popup = window.open(
            "",
            "popup",
            "width=500, height=700,"
          ) as Window;

          if (!!rmResvNo) {
            let param = localStorage.getItem("promCd")
              ? `${rmResvNo}/${localStorage.getItem("promCd")}`
              : `${rmResvNo}`;
            const url = `/app/view/pay/payRequest/${param}`;
            popup.location.href = url;

            //결제 완료 취소 모달창 오픈
            setIsOpen(true);
          }

          if (!rmResvNo) {
            // alert("예약 다시 진행");
            alertControl({
              isOpen: true,
              inner: "예약을 다시 진행하여 주세요.",
            });
          }
        }

        if (code === -1) {
          alertControl({
            isOpen: true,
            inner: message + "/ 객실을 다시 선택하여 주세요.",
            click: () => {
              // 객실 다시 선택
              onBkStep(1);

              setIsOpen(false);
              setIsSearch(true);
              // setBookInf()
            },
          });
        }
      }
    },
  });

  //로그인 체크
  const logChkMutation = useMutation({
    mutationFn: logChkApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            // 객실 예약 진행 ---
            if (resvInfRef.current) {
              bookMutation.mutate(resvInfRef.current);
            }
          },
        });
      }
    },
  });

  // 다음 단계 OR 예약하기
  const handleBookNext = async () => {
    if (!bookInf?.rmInf) {
      return alertControl({
        isOpen: true,
        inner: t("alr_msg_bk_rm"),
      });
    }

    if (bkStep < 3) {
      onBkStep(bkStep + 1);

      return;
    }
    if (bkStep === 3) {
      /**
       * 예약 완료 Api
       * 입력 데이터 가져오기
       */

      //

      const { emlId_1, emlId_2, emlId_3, cstMblCntyCd, ...res } = userInf;

      const inf = {
        ...res,
        cstEml: emlId_1 + "@" + (emlId_2 || emlId_3),
        cstMblCntyCd: cstMblCntyCd.replace(/\([^)]*\)/g, ""),
      };

      // 이메일, 휴대폰 번호 정규식 체크
      if (!emailRegex.test(inf.cstEml)) {
        alertControl({
          isOpen: true,
          inner: t("alr_reg_mail"),
        });
        return;
      }

      if (!phoneRegex.test(inf.cstMblNo)) {
        alertControl({
          isOpen: true,
          inner: "정확한 형식의 휴대폰번호를 입력하여 주세요.",
        });
        return;
      }

      // 이용약관 동의
      let isAllChecked = terms["01"] && terms["02"] && terms["03"];

      if (!isAllChecked) {
        return alertControl({
          isOpen: true,
          inner: t("alm_chk_info_bk"),
        });
      }

      const { dates, rmNo, rmTotCt, adltCnt, childCnt, opRgSeq, promCd } =
        bookInf;
      const bookInfo = {
        rmNo: rmNo,
        resvSDt: dates[0],
        resvEDt: dates[1],
        resvRmCt: rmTotCt,
        adltPerCt: adltCnt,
        chldPerCt: childCnt,
        babyPerCt: 0,
        opRgSeq: opRgSeq,
        promCd: promCd,
      };

      let params = {
        ...bookInfo,
        ...inf,
      };

      resvInfRef.current = params;

      /**
       * 로그인 상태 체크
       */

      logChkMutation.mutate();

      return;
      // }
    }
  };

  const inf = {
    rmCnt: state?.rmCnt,
    adltCnt: state?.adltCnt,
    childCnt: state?.childCnt,
  };

  const getModalInf = (e: any) => {
    const { target, rmInf } = e.detail;
    if (target === "bookInfEvent") {
      onBookInf({
        ...rmInf,
      });
    }
  };

  useEffect(() => {
    window.addEventListener("modalBookInfDispatch", getModalInf);

    return () => {
      window.removeEventListener("modalBookInfDispatch", getModalInf);
    };
  });

  return (
    <div className={bkStep !== 4 ? "book-inf" : "hidden"} ref={bookInfRef}>
      {/* 날짜선택 */}
      <div className="flex gap-2 mb-[18px]">
        <h3 className="sub">{t("bck_ttl_bk_inf")}</h3>
        <h3 className="sub text-blue-300">
          {bookInf?.dates.length === 2 &&
            getDurationDate(bookInf?.dates[0], bookInf?.dates[1])}
          {/* {bookInf?.dates.length === 2 &&
            bookInf.dateRange.length + t("txt_night_cmm")} */}
        </h3>
      </div>
      <BkCalendar />

      {/* 객실 선택 정보 */}
      <BookInfCard isOpen={true} inf={inf} />

      {/* 샘플 객실 선택 정보 */}

      <div className="flex gap-[10px] pt-6">
        <Button
          text={""}
          styels="icon-prev"
          onClick={() => {
            if (bkStep === 1) {
              navigate(-1);
              localStorage.removeItem("dates");
              return;
            }
            onBkStep(bkStep - 1);
          }}
        />
        <Button
          text={bkStep < 3 ? t("btn_nxt_bk") : t("sb_ttl_bk_cmplt")}
          styels="flex-1  "
          onClick={handleBookNext}
        />
      </div>
      <DefaultModal
        isOpen={isOpen}
        btnTxt={""}
        styles="max-w-[380px]"
        handleClose={() => {
          setIsOpen(false);
        }}
      >
        <ModalPayInnner
          handleClose={() => {
            setIsOpen(false);
          }}
        />
      </DefaultModal>
    </div>
  );
}
